<template>
  <div class="content">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('repository.back') }}</span>
    </div>
    <div class="actions">
      <!-- <a-button class="gray" type="primary" @click="change">原始文档</a-button> -->
      <a-button class="gray" type="primary" @click="fileSet" v-if="subsectionList.length">{{ $t('repository.fileSettings') }}</a-button>
    </div>
    <div class="comparison">
      <!-- <div class="comparison-item-left" v-if="showOriginalDoc">
        <div class="title">
          原始文档预览
        </div>
        <div class="details">
        </div>
      </div> -->
      <div class="no-data" v-if="subsectionList.length === 0">
        <img src="@/assets/img/pic_zhishiku@2x.png" alt="" srcset="" />
        <div class="no-data-text">
          <div class="no-data-text-title">{{ $t('repository.noSegmentData') }}</div>
        </div>
      </div>
      <div class="comparison-item-right" v-else>
        <div ref="details" class="details">
          <div class="total">{{ $t('repository.totalSegments', { total: pagination.total }) }}</div>
          <div v-for="(item, index) in subsectionList" :key="item.id">
            <div class="subsection-item">
              <div class="subsection-item-title">
                #{{ (pagination.page - 1) * pagination.pageSize + index + 1 }}
                <span>{{ item.content.length }} {{ $t('repository.characters') }}</span>
              </div>
              <div class="subsection-item-content">
                <!-- <pre> -->
                {{ item.content }}
                <!-- </pre> -->
              </div>
              <div class="subsection-actions">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ $t('repository.operations.edit') }}</span>
                  </template>
                  <a-icon type="edit" @click="handleEdit(item, index)" style="margin-right: 15px;" />
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ $t('repository.operations.delete') }}</span>
                  </template>
                  <img
                    src="@/assets/icons/icon_sc.png"
                    style="width: 15px; cursor: pointer"
                    @click="
                      editIndex = index
                      delVisible = true
                    "
                  />
                </a-tooltip>
              </div>
            </div>
          </div>
        </div>
        <Pagination
          v-if="pagination.total > 50"
          class="list-pagination"
          :pagination.sync="pagination"
          @handleTableChange="handlePaginationChange"
        />
      </div>
    </div>
    <!-- <a-button class="next" type="primary" @click="">完成</a-button> -->
    <TipModal
      @ok="handleDelete"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>${$t('repository.deleteConfirm.title')}</p>
        <p class='placeholder'>${$t('repository.deleteConfirm.content')}</p>`
      "
    />
    <a-modal
      v-model="visible"
      width="720px"
      :title="`#${editIndex + 1}`"
      @ok="handleOk"
      :confirm-loading="confirmLoading"
      wrapClassName="zsffd-modal"
    >
      <div class="modal-total" v-if="subsectionList.length > 0">{{ modalSize }} {{ $t('repository.characters') }}</div>
      <a-textarea
        style="border: 1px dashed #ccc;"
        v-model="editText"
        :placeholder="$t('repository.inputPlaceholder')"
        :auto-size="{ minRows: 10, maxRows: 16 }"
      />
    </a-modal>
  </div>
</template>

<script>
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import { getDocumentSegments, getDocumentSource, updateDocumentSegments, deleteDocumentSegments } from '@/api/aiApp.js'
import { dataSet } from '@/data/app.js'
const dataSetId = dataSet.id

export default {
  name: 'Details',
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      visible: false,
      delVisible: false,
      fileName: '',
      subsectionList: [],
      showOriginalDoc: false,
      editIndex: -1,
      editText: '',
      orgDocUrl: '',
      confirmLoading: false,
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      modalSize: 0
    }
  },
  mounted() {
    this.getDetails()
  },
  // 在methods中添加
  methods: {
    back() {
      this.$router.push({
        name: 'repositoryFileDetails',
        query: {
          id: this.$route.query.datasetId
        }
      })
    },
    handleEdit(item, index) {
      this.editIndex = index
      this.visible = true
      this.editText = item.content
      this.modalSize = this.subsectionList[this.editIndex < 0 ? 0 : this.editIndex].content.length
      console.log('编辑', item)
    },
    handleDelete() {
      deleteDocumentSegments(
        {
          datasetId: dataSetId,
          documentId: this.$route.query.id,
          segmentId: this.subsectionList[this.editIndex].id
        },
        {
          'X-App-Id': 'dataset'
        }
      ).then(res => {
        if (res === 204) {
          this.$message.success(this.$t('repository.messages.deleteSuccess'))
          this.getDetails()
          this.delVisible = false
        }
      })
    },
    getDetails() {
      getDocumentSegments(
        { datasetId: dataSetId, documentId: this.$route.query.id },
        {
          page: this.pagination.page,
          limit: this.pagination.pageSize
        },
        {
          'X-App-Id': 'dataset'
        }
      ).then(res => {
        if (res && res.data && res.data.length > 0) {
          this.documentId = res.data[0].document_id
          this.subsectionList = res.data.map(item => ({
            id: item.id,
            name: item.name,
            content: item.content
          }))
          this.pagination.total = res.total
          if (this.pagination.total <= 50) {
            this.$nextTick(() => {
              this.$refs.details.style.height = '100%'
            })
          }
        } else {
          this.subsectionList = []
        }
      })
    },
    getOrgDetails() {
      getDocumentSource(
        { datasetId: dataSetId, documentId: this.documentId },
        {
          'X-App-Id': 'dataset'
        }
      ).then(res => {
        if (res && res.id) {
          this.orgDocUrl = res.url
        }
      })
    },
    change() {
      this.showOriginalDoc = true
      this.getOrgDetails()
    },
    handleOk() {
      this.confirmLoading = true
      updateDocumentSegments(
        {
          datasetId: dataSetId,
          documentId: this.documentId,
          segmentId: this.subsectionList[this.editIndex].id
        },
        {
          'X-App-Id': 'dataset'
        },
        {
          segment: {
            content: this.editText
          }
        }
      ).then(res => {
        if (res && res.data) {
          this.$message.success(this.$t('repository.messages.saveSuccess'))
          this.visible = false
          this.confirmLoading = false
          this.getDetails()
        }
      })
    },
    fileSet() {
      // 使用 Vue Router 的 push 方法进行路由跳转
      this.$router.push({
        // 设置目标路由的名称为 createFlow
        name: 'createFlow',
        // 设置路由查询参数
        query: {
          // 将当前路由的 documentId 查询参数传递给目标路由
          id: this.$route.query.documentId,
          // 将当前路由的 datasetId 查询参数传递给目标路由
          datasetId: this.$route.query.datasetId
        }
      })
    },
    handlePaginationChange() {
      this.getDetails()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 18px 21px;
  position: relative;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    margin-bottom: 26px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .next {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20px;
  }
  .actions {
    position: absolute;
    right: 22px;
    top: 30px;
    /deep/ .ant-btn {
      margin-left: 20px;
    }
    .gray {
      background: linear-gradient(248deg, #72899d 0%, #9bb3c8 100%);
    }
  }
  .comparison {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    height: calc(100vh - 170px);
    .comparison-item-left {
      height: 100%;
      width: 47%;
      margin-right: 5%;
      .title {
        font-size: 16px;
        color: #000;
        margin-bottom: 10px;
        text-align: center;
        font-weight: bold;
      }
      .details {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        padding: 10px;
        padding-top: 0;
        overflow-y: auto;
      }
    }
    /deep/ .ant-select-selection-selected-value {
      color: #000;
    }
    .comparison-item-right {
      flex: 1;
      height: 100%;
      position: relative;
      background: #fbfbfb;
      .list-pagination {
        position: absolute;
        bottom: -15px;
        height: 40px;
        width: calc(100%);
      }
      .title {
        font-size: 16px;
        color: #000;
        margin-bottom: 10px;
        text-align: center;
        font-weight: bold;
      }
      .details {
        width: 100%;
        height: 95%;
        border-radius: 4px;
        padding: 10px;
        padding-top: 0;
        overflow-y: auto;
        .total {
          color: #687f9c;
          margin: 12px 0;
          font-size: 16px;
          font-weight: bold;
        }
        .subsection-item {
          background: #fff;
          margin-bottom: 20px;
          border: solid 1px #f5f5f6;
          border-radius: 4px;
          padding: 10px;
          position: relative;
          transition: background-color 0.3s ease;

          &:hover {
            background-color: #f7f7f7;
            .subsection-actions {
              display: block;
            }
          }

          .subsection-actions {
            display: none;
            position: absolute;
            right: 10px;
            top: 10px;
            /deep/ .ant-btn {
              padding: 0 5px;
            }
          }
          .subsection-item-title {
            font-size: 18px;
            color: #000;
            margin-bottom: 10px;
            font-weight: bold;
            span {
              color: #838383;
              font-size: 12px;
              font-weight: normal;
              padding-left: 10px;
            }
          }
          .subsection-item-content {
            font-size: 14px;
            color: #000;
            line-height: 1.8em;
            overflow-wrap: break-word;
            word-wrap: break-word;
            width: 100%;
          }
        }
      }
    }
    .no-data {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      height: 500px;
      img {
        width: 200px;
        height: 200px;
      }
      .no-data-text {
        text-align: center;
        font-size: 14px;
        margin-top: -30px;
        font-weight: bold;
      }
    }
  }
}
</style>
<style lang="less">
.select-option-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    color: #999999;
  }
  .info {
    font-size: 14px;
    color: #03b879;
    font-weight: normal;
    padding-left: 10px;
  }
}
.modal-total {
  position: absolute;
  top: 18px;
  left: 57px;
  color: #838383;
  font-size: 12px;
}
.zsffd-modal {
  .ant-modal-footer {
    padding-bottom: 15px !important;
  }
  .ant-modal-body {
    padding-bottom: 15px !important;
  }
  textarea {
    padding: 10px;
    background-color: #fafafa;
  }
}
</style>
